export default __webpack_public_path__ + "static/media/SonikaLovelace.5d56e767.png";